import type {AppearanceOptions} from '@stripe-internal/embedded-theming';
import {
  getAccessibleTextColor,
  getBrand600Color,
} from '@stripe-internal/embedded-theming';

export type InheritedStyles = {
  fontFamily?: string;
};

export type ThemeOverrides = {
  color: Partial<{
    brand500: string;
    brand600: string;
    info500: string;
    accessiblePrimaryText: string;
  }>;
  typeface: Partial<Record<string, string>>;

  // interop with new theming api
  backgroundColor: Partial<{
    container: string;
  }>;
};

export function getThemeOverrides(
  ignoreThemingVaues: boolean,
  appearance: AppearanceOptions | undefined,
): ThemeOverrides {
  const output: ThemeOverrides = {color: {}, typeface: {}, backgroundColor: {}};

  if (ignoreThemingVaues) {
    return output;
  }

  const primaryColor = appearance?.variables?.colorPrimary;

  if (primaryColor) {
    output.color = {
      brand500: primaryColor,
      brand600: getBrand600Color(primaryColor),
      info500: primaryColor,
      // Has no effect on Sail Tokens, is undefined if primary color cannot be parsed
      accessiblePrimaryText: getAccessibleTextColor(primaryColor),
    };

    if (!output.color.accessiblePrimaryText) {
      // Unset color options if primary color appears to be malformed
      output.color = {};
    }
  }

  const fontFamily = appearance?.variables?.fontFamily;
  if (fontFamily) {
    output.typeface = {
      ui: fontFamily,
      monospace: fontFamily,
    };
  }

  // Interop needed with new Theming API
  if (appearance?.variables?.offsetBackgroundColor) {
    output.backgroundColor = {
      container: appearance?.variables?.offsetBackgroundColor,
    };
  }

  return output;
}
